export enum PaymentMethodType {
    Credit = 0,
    ACH = 1,
    OVERFLOW = 2,
    PAYLATER = 3
}